import { SelectionModel } from '@angular/cdk/collections';
type CoraState = 'searching' | 'shortlisting' | 'parsing' | 'finished' | null;
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/@core/services/app.service';
import { AuthService } from 'src/@core/services/auth.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { TwilioService } from 'src/@core/services/twilio.service';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';
import { ThemeService } from 'src/@core/services/theme.service';
import logoLinkedIn from '@iconify/icons-logos/linkedin';
import logoGitHub from '@iconify/icons-logos/github';
import logoTwitter from '@iconify/icons-logos/twitter';
import logoFacebook from '@iconify/icons-logos/facebook';
import { WorkflowPopupComponent } from '../../workflow-popup/workflow-popup.component';
import { MatDialog } from '@angular/material';
import { WorkflowDataService } from 'src/@core/services/job/workflow-data.service';
import { CreateLeadsUserComponent } from '../../view-project/create-leads-user/create-leads-user.component';
import { CallAgentComponent } from 'src/app/modules/agents/call-agent/call-agent.component';
import { API_ACCOUNT_CREDIT, API_AUTH, API_WEB_SOCKET, API_WHATSAPP_AGENT, DOWNLOAD_LEADS_EXCEL, API_WHATSAPP_SESSION, API_WHATSAPP_STATUS, API_WHATSAPP_QR, API_WHATSAPP_AGENT_SEND, PROJECT_API_KEY } from 'src/@core/services/util/api.endpoints';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ClientProfileComponent } from '../client-profile/client-profile.component';
import { permissions } from 'src/app/shared/helpers/roles-permissions';
import { RunOutreachPopupComponent } from '../run-outreach-popup/run-outreach-popup.component';
import { WebSocketService } from 'src/@core/services/websocket.service';
import { environment } from 'src/environments/environment';
import { AdjustIcpComponent } from '../../adjust-icp/adjust-icp.component';
import { GoogleAccountPopupComponent } from '../../google-account-popup/google-account-popup.component';
import { gapi } from 'gapi-script';
import { TestAgentDialogComponent } from './test-agent-dialog.component';
import { WABAConnectDialogComponent } from './waba-connect-dialog.component';
import { TrialEndedPopupComponent } from 'src/app/modules/credits/trial-ended-popup/trial-ended-popup.component';
import { UpgradeSubscriptionPopupComponent } from 'src/app/modules/credits/upgrade-subscription-popup/upgrade-subscription-popup.component';

interface UserToken {
  userId: string;
  email: string;
  googleRefreshToken: string;
}

interface WhatsAppResponse {
  message: string;
  qr_code_url: string;
  session_id: string;
  success: boolean;
}

@Component({
  selector: 'hour4u-admin-view-project-details-new',
  templateUrl: './view-project-details-new.component.html',
  styleUrls: ['./view-project-details-new.component.scss']
})
export class ViewProjectDetailsNewComponent implements OnInit, AfterViewInit, OnDestroy {
  hideUploadUI: boolean = false;
  coraState: CoraState = 'searching';
  wsConnected: boolean = false;
  // Queue for leads to score after WS is connected
  private leadsToScoreQueue: any[] = [];
  @Input() apolloLeads?: any = null;
  @Input() refreshTrigger: number;
  @Input() projectDetails: any;
  @Input() pageIndex?: number = 1;
  @Input() pageSize?: number = 10;
  @Input() pageSizeOptions?: number[] = [10, 20, 50, 100, 200];
  @Input() currentRange?: string = '';
  @Input() hideCallButton: boolean = false;
  @Output() pageChange = new EventEmitter<{ pageNum: number; pageSize: number; loadMore?: boolean; reset?: boolean }>();
  @Output() changeTab = new EventEmitter<string>();
  /** Server-side lead search — parent refetches /hoaProjectLeads with these filters. */
  @Output() leadsSearch = new EventEmitter<{ name: string | null; mobile: string | null }>();
  @Input() isLeadsLoading: boolean = false;
  @Input() isLoadingMoreLeads: boolean = false;
  @Input() leadsHasNextPage: boolean = false;
  pageNumbers: Array<number | string> = [];
  searchProjectName: any = null;
  selection = new SelectionModel<any>(true, []);
  dataSource = [];
  allRowsSelected: boolean = false;
  profile = this.appService.getCurrentAccount();
  private intervalId: any;
  diameter = 40;
  loaderColor: string = 'primary';
  mode = 'indeterminate';
  isLoading: boolean = false;
  currentAudio: HTMLAudioElement | null = null;
  playingRecordingId: string | null = null;
  // pageIndex = 1;
  // pageSize = 10;
  pagination: any;
  // currentRange: string = '';
  //   pageSizeOptions: number[] = [10, 20, 50, 100, 200, 500];
  isExporting: boolean = false;
  currentRecordingUrl: string | null = null;
  metadata: any;
  call: any;

  logoLinkedIn = logoLinkedIn;
  logoGitHub = logoGitHub;
  logoTwitter = logoTwitter;
  logoFacebook = logoFacebook;

  showEmploymentModal = false;
  selectedEmploymentHistory: any[] = [];
  workflowPopupData: any[];
  credits: any = null;
  remainingCredits: number;
  permissions = permissions;
  workflowTabTriggered: boolean = false;
  chatMessages: { text: string, sender: 'user' | 'cora' }[] = [];
  newMessage: string = '';
  isTyping: boolean = false;

  showAgentStatus: boolean = true;
  private queuePollingAttempts = 0;
  private maxQueuePollingAttempts = 6;
  private queuePollingInterval: any;

  selectedLeads: number = 0;
  processedLeads: number = 0;
  requiredLeads: number = 0;
  agentStatus: string;
  parsedLeadsCount: any;
  process: string = 'Completed';
  shortlistedText: string = 'Cora is shortlisting the leads';
  completedText: string = 'Cora has finished shortlisting.';
  tickIconUrl: string = 'assets/orange-tick.svg';
  totalParsedLeads: number = 0;
  searchText: string = '';
  /** Active server-side filters derived from searchText. */
  leadsSearchName: string | null = null;
  leadsSearchMobile: string | null = null;
  private searchDebounceTimer: any = null;
  private readonly SEARCH_DEBOUNCE_MS = 350;
  filteredDataSource: any[] = [];
  objectKeys = Object.keys;
  useApollo: boolean = false;
  disableBtn: boolean;
  cameFromCreateFlow: boolean = false;

  projectIdFromState: string = '';

  // Indicates if project details are fully loaded
  projectDetailsLoaded: boolean = false;
  existingAccounts: UserToken[] = [];
  whatsappResponse: WhatsAppResponse;
  showWhatsappQRPopup: boolean = false;
  qrCodeUrl: SafeResourceUrl | string = '';
  whatsappSessionId: string = '';
  whatsappStatus: any = null;
  isWhatsappConnected: boolean = false;
  private whatsappStatusInterval: any;
  // QR connect robustness: bounded QR-fetch retries (session may need a moment
  // to initialise) and a hard poll cap so status polling never leaks forever.
  private qrFetchAttempts: number = 0;
  private readonly QR_FETCH_MAX_ATTEMPTS: number = 6;   // ~ up to ~9s of retries
  private whatsappPollAttempts: number = 0;
  private readonly WHATSAPP_POLL_MAX_ATTEMPTS: number = 100; // 100 x 3s = 5 min

  constructor(
    public themeService: ThemeService,
    private appService: AppService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private notify: NotificationService,
    public enterpriseAdminService: EnterpriseAdminService,
    private twilioService: TwilioService,
    private jobService: JobService,
    private dialog: MatDialog,
    private workflowDataService: WorkflowDataService,
    private http: HttpClient,
    private wsService: WebSocketService,
    private sanitizer: DomSanitizer
  ) {

  }

  ngOnInit() {
    console.log("call data", this.projectDetails, this.hideCallButton);

    // WebSocket message subscription logic
    this.wsService.messages$.subscribe((response) => {
      if (response === 'CONNECTED') {
        console.log('✅ WebSocket connection established');
        this.wsConnected = true;
      } else if (response && response.lead && response.lead.people_id) {
        const updatedLead = response.lead;
        const index = this.dataSource.findIndex(lead => lead.people_id === updatedLead.people_id);
        if (index !== -1) {
          this.dataSource[index] = updatedLead;
        }

        const filteredIndex = this.filteredDataSource.findIndex(lead => lead.people_id === updatedLead.people_id);
        if (filteredIndex !== -1) {
          this.filteredDataSource[filteredIndex] = updatedLead;
        }
        // Always re-rank the leads after a scoring update
        this.filteredDataSource = this.rankLeadsByScore(this.filteredDataSource);
        // Check if all leads are scored
        if (this.filteredDataSource.every(lead => lead.total_score !== 'Calculating Score')) {
          this.coraState = 'finished';
        }
      }
      // Handle WebSocket parsing success
      else if (response && (response.type === 'upload_parsing_success' || response.status === 'parsed')) {
        console.log('✅ Leads parsed successfully via WebSocket');
        this.hideUploadUI = true;
        this.showAgentStatus = true;
        this.coraState = 'finished';
        this.reloadProjectMetadataThenLeads(() => {
          this.totalParsedLeads = (this.dataSource && this.dataSource.length) || 0;
        });
      }
      // ✅ Handle final WebSocket confirmation for uploadLeads
      else if (response && response.action === 'uploadLeads' && response.success) {
        console.log('✅ Final WebSocket confirmation for uploadLeads received');
        this.hideUploadUI = true;
        this.showAgentStatus = true;
        this.coraState = 'finished';
        this.notifyUploadOutcome(response.data);
        this.reloadProjectMetadataThenLeads(() => {
          this.totalParsedLeads = (this.dataSource && this.dataSource.length) || 0;
        });
      }
      // Upload that ended before any lead was inserted, because every row was a
      // duplicate. It arrives as its own message rather than the one above, so
      // the user would otherwise be told nothing at all.
      else if (response && response.type === 'upload_complete') {
        this.notifyUploadOutcome(response);
      }
    });

    const state = history.state;
    console.log("State from history:", state);
    this.cameFromCreateFlow = state && state.createProjectPayloadRaw ? true : false;
    this.useApollo = state && state.useApollo ? true : false;

    if (state) {
      if (state.createProjectPayloadRaw && state.createProjectPayloadRaw.projectId) {
        this.projectIdFromState = state.createProjectPayloadRaw.projectId;
      } else if (state.projectId) {
        this.projectIdFromState = state.projectId;
      }
    }

    if (this.cameFromCreateFlow && this.useApollo) {
      this.coraState = 'searching';
    }

    // Trigger project creation if navigated here with payload
    this.createProject();

    this.route.params.subscribe(data => {
      console.log(data);
      console.log("param data", this.apolloLeads);
      //this.getProjectById(this.profile.entity.id, data.id)
      //this.getCurrentRole();
      //this.ctaSet();
    });
    if (this.projectDetails && this.projectDetails.project_name) {
      this.jobService['currentProjectName'] = this.projectDetails.project_name;
      this.projectDetailsLoaded = true;
      this.checkWhatsAppStatus();
    }
    // Only call sendLeadsForScoringViaWS if both projectDetails and apolloLeads are defined and there are leads needing scoring
    if (
      this.projectDetails &&
      this.apolloLeads &&
      this.apolloLeads.leads &&
      this.apolloLeads.leads.some(lead => lead.total_score === 'Calculating Score')
    ) {
      this.sendLeadsForScoringViaWS();
    } else {
      //this.coraState = 'finished';
    }

    // (Moved preloaded leads check to ngOnChanges)
    // Ensure projectIdFromState is set from route param if still empty, but only if useApollo is false
    this.route.params.subscribe(function (data) {
      if (!this.useApollo && !this.projectIdFromState && data && data.id) {
        this.projectIdFromState = data.id;
      }
      // Call checkWhatsAppStatus once we have project ID from route
      if (data && data.id) {
        console.log('Got project ID from route:', data.id);
        this.checkWhatsAppStatus(data.id);
      }
    }.bind(this));

    // Call checkWhatsAppStatus if projectDetails is already available
    console.log('ngOnInit - projectDetails:', this.projectDetails);
    if (this.projectDetails && this.projectDetails.project_id) {
      console.log('Calling checkWhatsAppStatus from ngOnInit');
      this.checkWhatsAppStatus();
    } else {
      console.log('projectDetails not ready in ngOnInit');
    }

    // Deep-link from Arya → Channels: ?manageWhatsapp=1 auto-opens the WhatsApp
    // connect/disconnect dialog once the project has loaded.
    this.route.queryParams.subscribe(q => {
      if (q && q['manageWhatsapp'] === '1') { this.autoOpenWabaDialog(); }
    });
  }

  ngAfterViewInit() {
    console.log('ngAfterViewInit - projectDetails:', this.projectDetails);
    if (this.projectDetails && this.projectDetails.project_id) {
      console.log('Calling checkWhatsAppStatus from ngAfterViewInit');
      this.checkWhatsAppStatus();
    } else {
      console.log('projectDetails still not ready in ngAfterViewInit');
    }
  }

  sendLeadsForScoringViaWS() {
    if (this.projectDetails && this.projectDetails.icp_profile && this.apolloLeads && this.apolloLeads.leads) {
      this.coraState = 'parsing';
      const leadsToScore = this.apolloLeads.leads.filter(lead => lead.total_score === 'Calculating Score');
      const icpProfile = this.projectDetails.icp_profile;
      const messagesToSend = leadsToScore.map(lead => ({
        action: 'scoreLeads',
        data: {
          entity_id: this.projectDetails.entity_id,
          project_id: this.projectDetails.project_id,
          lead,
          icp_profile: icpProfile
        }
      }));

      // Wait for WebSocket connection before sending messages
      const sub = this.wsService.messages$.subscribe((response) => {
        if (response === 'CONNECTED') {
          console.log('✅ WebSocket connected. Sending leads...');
          this.wsService.sendMultiple(messagesToSend);
          this.coraState = 'shortlisting';
          sub.unsubscribe(); // Clean up the subscription
        }
      });

      // Also initiate the connection
      this.wsService.connect(API_WEB_SOCKET);
    }
  }

  ngOnDestroy(): void {
    this.wsService.close();
    this.stopStatusPolling();
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = true;

    if (changes['apolloLeads'] && changes['apolloLeads'].currentValue) {
      this.isLoading = false;
      this.apolloLeads = changes['apolloLeads'].currentValue;
      this.dataSource = this.apolloLeads.leads;
      this.filteredDataSource = this.rankLeadsByScore(this.dataSource);
      // Check for existing leads that are already scored
      if (this.dataSource && this.dataSource.length > 0) {
        const allScored = this.dataSource.every(function (lead) {
          return lead.total_score !== 'Calculating Score';
        });
        if (allScored) {
          this.coraState = 'finished';
        } else if (this.useApollo) {
          this.coraState = 'shortlisting';
        }
      }

      if (this.apolloLeads.records && Array.isArray(this.apolloLeads.records)) {
        this.dataSource = this.dataSource.map(lead => {
          const matched = this.apolloLeads.records.find(record =>
            record.client_number === lead.client_number || record.client_email === lead.client_email
          );
          return {
            ...lead,
            status_reason: matched && matched.status_reason ? matched.status_reason : '',
            questions_asked: matched && matched.questions_asked ? matched.questions_asked.map(q => q.question + '\n' + q.answer).join('\n\n') : ''
          };
        });
      }

      if (
        this.projectDetails &&
        this.projectDetails.copilotDetails &&
        this.projectDetails.copilotDetails.chat_details &&
        this.projectDetails.copilotDetails.chat_details.length > 0 &&
        this.projectDetails.copilotDetails.chat_details[0].messages &&
        this.projectDetails.copilotDetails.chat_details[0].messages.length > 0
      ) {
        const latestChat = this.projectDetails.copilotDetails.chat_details.find(chat => chat.active);

        if (latestChat && latestChat.messages && latestChat.messages.length > 0) {
          this.chatMessages = latestChat.messages.map(msg => ({
            text: msg.content,
            sender: msg.role === 'assistant' ? 'cora' : 'user'
          }));
        } else {
          this.chatMessages = [];
        }
      } else {
        this.chatMessages = [];
      }
      this.pagination = this.apolloLeads.pagination;
      // Keep local pageSize in sync with backend (new pagination shape)
      if (this.pagination && this.pagination.page_size != null) {
        this.pageSize = Number(this.pagination.page_size) || this.pageSize;
      } else if (this.pagination && this.pagination.items_per_page != null) {
        this.pageSize = Number(this.pagination.items_per_page) || this.pageSize;
      } else if (this.pagination && this.pagination.currentPageSize != null) {
        this.pageSize = Number(this.pagination.currentPageSize) || this.pageSize;
      }
      // Prefer parent input, else derive from pagination.next_token
      if (!this.leadsHasNextPage && this.pagination) {
        this.leadsHasNextPage = !!(
          (this.pagination.has_next_page === true || this.pagination.has_more === true) &&
          (this.pagination.next_token || this.pagination.nextToken)
        );
      }
      this.updateRange();
      this.pageNumbers = this.buildPageNumbers(this.getLeadsTotalPages(), this.getLeadsPageNum());

      // Call sendLeadsForScoringViaWS if both projectDetails and apolloLeads are present and there are leads needing scoring
      if (
        this.projectDetails &&
        this.apolloLeads &&
        this.apolloLeads.leads &&
        this.apolloLeads.leads.some(lead => lead.total_score === 'Calculating Score')
      ) {
        this.sendLeadsForScoringViaWS();
      } else {
        this.coraState = 'finished';
      }
    } else if (
      (!this.apolloLeads || !this.apolloLeads.leads) &&
      this.projectDetails &&
      this.projectDetails.project_id
    ) {
      // Metadata may be present without leads — load leads from /hoaProjectLeads
      // and refresh project metadata (no leads) from /hoaProject.
      this.fetchProjectMetadataAndLeads();
    } else {
      this.isLoading = false;
    }

    if (changes['projectDetails'] && changes['projectDetails'].currentValue) {
      console.log("Received projectDetails in child component:", this.projectDetails);
      this.projectDetailsLoaded = true;
      // Call sendLeadsForScoringViaWS if both projectDetails and apolloLeads are present and there are leads needing scoring
      if (
        this.projectDetails &&
        this.apolloLeads &&
        this.apolloLeads.leads &&
        this.apolloLeads.leads.some(lead => lead.total_score === 'Calculating Score')
      ) {
        this.sendLeadsForScoringViaWS();
      } else {
        this.coraState = 'finished';
      }
    }
  }


  sendMessage() {
    const message = this.newMessage.trim();
    if (!message) return;

    this.chatMessages.push({ text: message, sender: 'user' });
    this.newMessage = '';
    this.isTyping = true;

    this.jobService.sendChatMessage(this.profile.entity.id, this.projectDetails.project_id, message)
      .subscribe(
        (res: any) => {
          this.isTyping = false;
          const responseText = res.assistant_message || res.message || 'No response received.';
          const formatted = this.formatAssistantMessage(responseText);
          this.chatMessages.push({ text: formatted, sender: 'cora' });
          // Immediately update dataSource and filteredDataSource if leads are returned directly from chat response
          if (res.leads && res.leads.length > 0) {
            console.log("changing leads")
            this.dataSource = res.leads;
            this.filteredDataSource = this.rankLeadsByScore(this.dataSource);
          }
          this.scrollToBottom();

          // ✅ New logic for checking process
          if (res.process && res.process === 'Completed') {
            this.reloadProjectMetadataThenLeads();
          }
        },
        (error) => {
          this.isTyping = false;
          console.error('Error sending chat message:', error);
          this.chatMessages.push({ text: 'Oops! Something went wrong.', sender: 'cora' });
          this.scrollToBottom();
        }
      );

    this.scrollToBottom();
  }
  selectAllCandidates() {
    if (this.filteredDataSource && this.filteredDataSource.length) {
      this.filteredDataSource.forEach(candidate => this.selection.select(candidate));
    }
  }
  formatAssistantMessage(raw: string): string {
    try {
      // Decode if necessary
      raw = decodeURIComponent(escape(raw));
    } catch (e) {
      console.warn("Failed to decode message:", e);
    }

    let formatted = raw
      .replace(/\\n/g, '\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/\n/g, '<br>')
      .replace(/(\*\*)(.*?)\1/g, '<b>$2</b>');

    return formatted;
  }

  scrollToBottom() {
    setTimeout(() => {
      const container = document.querySelector('.chat-body');
      if (container) container.scrollTop = container.scrollHeight;
    }, 100);
  }

  // Select all rows 
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }
  // Getter to check if multiple rows are selected
  get isMultipleRowsSelected(): boolean {
    return this.selection.selected.length > 1;
  }

  masterToggle(event: any) {
    if (event.checked) {
      this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.forEach(row => { this.selection.select(row) });
      this.isAllSelected() ? this.allRowsSelected = true : this.allRowsSelected = false;
    } else {
      this.selection.clear();
    }
  }

  callSelectedAllUsers() {
    console.log(this.selection, this.projectDetails)
    let callObj = [];
    if (this.selection && this.selection.selected.length) {
      this.selection.selected.forEach(element => {
        let obj = {
          "client_name": element.client_name,
          "client_email": element.client_email,
          "client_number": element.client_number,
          "entity_id": this.profile.entity.id,
          "tts": "elevenlabs",
          "language": this.projectDetails.language || "en",
          "voice": this.projectDetails.voice || "male",
        }
        callObj.push(obj);
      });

      this.enterpriseAdminService.callSelectedUsers(this.projectDetails.agent_id, this.projectDetails.project_id, this.projectDetails.entity_id, callObj).subscribe(res => {
        this.notify.showMessage(
          `Connecting users...`,
          30000
        );
        // No empty status-polling interval — user can refresh Connected tab
      }, (err => {
        console.log(err)
      }))
    } else {
      this.notify.showMessage(
        `Please select users first!`,
        30000
      );
    }
  }

  getUpdatingStatus(job_id) {
    this.enterpriseAdminService.getUpdatedStatus(job_id, this.profile.entity.id,).subscribe(res => {

    }, (err => {
      console.log(err)
    }))
  }

  exportData() {

  }

  /**
   * Swap the lead table out for the uploader while the project has nothing to
   * list — same condition the uploader always used, just applied where the
   * table sits instead of above the entire page.
   *
   * Apollo projects are excluded because their leads arrive from a search
   * rather than an upload, and hideUploadUI covers the window just after an
   * upload when leads are still being parsed.
   *
   * An active search is excluded too: a term that matched nothing empties
   * dataSource without the project being empty, and swapping the table out
   * would take the search box — and the only way back — with it. The
   * "No leads match" message inside the table covers that case. Same for a
   * load in flight, which would otherwise flash the uploader mid-fetch.
   */
  get showUploaderInsteadOfTable(): boolean {
    return this.projectDetailsLoaded
      && !this.hideUploadUI
      && !this.useApollo
      && !this.isLeadsSearchActive()
      && !this.isLeadsLoading
      && !(this.dataSource && this.dataSource.length);
  }

  /**
   * True only while leads are actually being discovered — an Apollo search or
   * an upload being parsed — which is the only time the searching animation
   * means anything.
   *
   * Note coraState initialises to 'searching', so it cannot be trusted on its
   * own: any project that simply has no leads would otherwise sit under a
   * "Searching for the Best Results" spinner forever. Apollo has to be in play
   * for a search, and parsing is only ever set by a real upload.
   */
  get isLeadDiscoveryRunning(): boolean {
    if (this.coraState === 'parsing') {
      return true;
    }
    return !!this.useApollo
      && (this.coraState === 'searching' || this.coraState === 'shortlisting');
  }

  /**
   * Re-request the first page of leads from the empty state.
   *
   * Covers both reasons the list can be empty — the project genuinely has
   * none, or the load failed — since the component cannot tell them apart
   * from here. Clears an active search first so the retry is not silently
   * filtered down to nothing again.
   */
  retryLoadLeads() {
    if (this.isLeadsLoading) {
      return;
    }
    if (this.searchText) {
      this.searchText = '';
      this.filterCandidates();
    }
    this.pageChange.emit({
      pageNum: 1,
      pageSize: this.getLeadsPageSize(),
      reset: true
    });
  }

  /** Token-based: load next page of leads (append). Prefer over numbered pages. */
  onLoadMoreLeads() {
    if (this.isLeadsLoading || this.isLoadingMoreLeads || !this.canLoadMoreLeads()) {
      return;
    }
    this.pageChange.emit({
      pageNum: this.getLeadsPageNum() + 1,
      pageSize: this.getLeadsPageSize(),
      loadMore: true
    });
  }

  canLoadMoreLeads(): boolean {
    if (this.leadsHasNextPage) {
      return true;
    }
    return this.canNext();
  }

  onNext() {
    // Legacy numbered next — maps to load-more for token pagination
    this.onLoadMoreLeads();
  }

  onPageSelect(page: number | string) {
    // Numbered pages are expensive on the backend; only reset if jumping to page 1
    if (page === 1) {
      this.pageChange.emit({
        pageNum: 1,
        pageSize: this.getLeadsPageSize(),
        reset: true
      });
    }
  }

  onPrev() {
    // Token pagination is forward-only; previous = hard reset to first page
    this.pageChange.emit({
      pageNum: 1,
      pageSize: this.getLeadsPageSize(),
      reset: true
    });
  }

  updateRange() {
    const loaded = (this.dataSource && this.dataSource.length) || 0;

    // While searching, the backend nulls total_records (the cached count covers
    // the whole project, not the match set) — so never show a total here.
    if (this.isLeadsSearchActive()) {
      this.currentRange = loaded > 0
        ? `${loaded} match${loaded === 1 ? '' : 'es'}${this.leadsHasNextPage ? '+' : ''}`
        : '';
      return;
    }

    const total = this.getLeadsTotalCount();

    if (total != null) {
      this.currentRange = `${loaded} of ${total} leads`;
      return;
    }
    if (loaded > 0) {
      this.currentRange = `${loaded} lead${loaded === 1 ? '' : 's'} loaded`;
      return;
    }
    this.currentRange = '';
  }

  buildPageNumbers(totalPages: number, currentPage: number): Array<number | string> {
    if (!totalPages) return [];

    const pages: Array<number | string> = [];

    const addPage = (page: number | string) => {
      if (pages[pages.length - 1] !== page) {
        pages.push(page);
      }
    };

    if (totalPages <= 6) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    addPage(1);
    if (currentPage > 3) addPage('...');

    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);
    for (let i = startPage; i <= endPage; i++) addPage(i);

    if (currentPage < totalPages - 2) addPage('...');
    addPage(totalPages);

    return pages;
  }

  trackByPageNumber(index: number, _page: number | string): number {
    return index;
  }

  isEllipsis(page: number | string): boolean {
    return page === '...';
  }

  onPageSizeChange(value: any) {
    const newSize = parseInt(value, 10);
    this.pageSize = newSize;
    this.setLeadsPageSize(this.pageSize);
    this.setLeadsPageNum(1); // Reset to the first page after size change
    this.updateRange();
    this.pageNumbers = this.buildPageNumbers(this.getLeadsTotalPages(), this.getLeadsPageNum());
    this.pageChange.emit({
      pageNum: this.getLeadsPageNum(),
      pageSize: this.getLeadsPageSize(),
    });
  }

  // --- Leads pagination helpers (supports both old + new backend shapes) ---
  getLeadsPageNum(): number {
    if (this.pagination && this.pagination.page_num != null) return Number(this.pagination.page_num) || 1;
    if (this.pagination && this.pagination.currentPageNum != null) return Number(this.pagination.currentPageNum) || 1;
    return this.pageIndex || 1;
  }

  getLeadsPageSize(): number {
    if (this.pagination && this.pagination.items_per_page != null) return Number(this.pagination.items_per_page) || this.pageSize || 10;
    if (this.pagination && this.pagination.currentPageSize != null) return Number(this.pagination.currentPageSize) || this.pageSize || 10;
    return this.pageSize || 10;
  }

  getLeadsTotalCount(): number | null {
    // Only show totals when backend provided them (include_total). Never invent from list length.
    if (!this.pagination) {
      return null;
    }
    if (this.pagination.total_records != null && this.pagination.total_records !== '') {
      const n = Number(this.pagination.total_records);
      return Number.isFinite(n) ? n : null;
    }
    if (this.pagination.total_count != null) {
      const n = Number(this.pagination.total_count);
      return Number.isFinite(n) ? n : null;
    }
    if (this.pagination.totalElements != null) {
      const n = Number(this.pagination.totalElements);
      return Number.isFinite(n) ? n : null;
    }
    return null;
  }

  /** Label for stats / range — only when total_records is non-null. */
  getLeadsTotalLabel(): string {
    const total = this.getLeadsTotalCount();
    if (total == null) {
      return '';
    }
    const approx =
      this.pagination &&
      (this.pagination.is_approximate === true || this.pagination.is_approximate === 'true');
    return (approx ? '~' : '') + String(total);
  }

  getLeadsTotalPages(): number {
    // Do not derive page counts from approximate totals for navigation
    if (this.pagination && this.pagination.total_pages != null) {
      const n = Number(this.pagination.total_pages);
      return Number.isFinite(n) ? n : 0;
    }
    if (this.pagination && this.pagination.totalPages != null) {
      const n = Number(this.pagination.totalPages);
      return Number.isFinite(n) ? n : 0;
    }
    return 0;
  }

  canPrev(): boolean {
    if (this.pagination && this.pagination.has_previous_page !== undefined) {
      return this.pagination.has_previous_page === true;
    }
    return this.getLeadsPageNum() > 1;
  }

  canNext(): boolean {
    if (!this.pagination) {
      return false;
    }
    if (this.pagination.has_next_page !== undefined) {
      return this.pagination.has_next_page === true;
    }
    if (this.pagination.has_more != null) {
      return !!this.pagination.has_more;
    }
    if (this.pagination.next_token || this.pagination.nextToken) {
      return true;
    }
    return false;
  }

  /**
   * Load project metadata from /hoaProject (no leads) and leads from /hoaProjectLeads.
   */
  private fetchProjectMetadataAndLeads(): void {
    this.reloadProjectMetadataThenLeads();
  }

  /**
   * Tell the user what actually happened to their upload.
   *
   * Duplicates are dropped before the leads are inserted, because a number the
   * project already holds makes the calling vendor reject the whole batch it
   * travels in. Without this the rows simply vanish: the file said 5000, the
   * project shows 4995, and nothing explains the difference.
   */
  private notifyUploadOutcome(data: any): void {
    if (!data) {
      return;
    }

    const duplicatesRemoved = Number(data.duplicates_removed) || 0;
    const inFile = Number(data.duplicates_in_file) || 0;
    const alreadyPresent = Number(data.duplicates_already_in_project) || 0;

    if (duplicatesRemoved > 0) {
      const leadWord = duplicatesRemoved === 1 ? 'lead was' : 'leads were';
      // Prefer the reason the backend gave; fall back to composing it from the
      // counts so the toast still explains itself if the wording ever changes.
      let description = data.duplicate_message;
      if (!description) {
        const reasons = [];
        if (alreadyPresent > 0) {
          reasons.push(alreadyPresent + ' already in this project');
        }
        if (inFile > 0) {
          reasons.push(inFile + ' repeated in the file');
        }
        description = reasons.length ? reasons.join(', ') + '.' : '';
      }

      this.notify.showMessage(
        duplicatesRemoved + ' duplicate ' + leadWord + ' skipped',
        8000,
        undefined,
        description
      );
    }

    // Leads that reached the project but not the calling vendor: the campaign
    // will never dial them, and previously nothing said so.
    const vendorFailed = Number(data.vocallabs_failed_leads) || 0;
    if (vendorFailed > 0) {
      this.notify.showMessage(
        vendorFailed + ' leads could not be sent for calling',
        10000,
        undefined,
        data.vocallabs_warning ||
          'They were saved to the project but the campaign will not call them until they are re-synced.'
      );
    }
  }

  /**
   * Refresh project metadata then re-load leads list from /hoaProjectLeads.
   * Never reads project.leads from the metadata response.
   */
  private reloadProjectMetadataThenLeads(after?: () => void): void {
    const entityId = this.profile && this.profile.entity && this.profile.entity.id;
    const projectId = this.projectDetails && this.projectDetails.project_id;
    if (!entityId || !projectId) {
      this.isLoading = false;
      if (after) {
        after();
      }
      return;
    }

    this.isLoading = true;
    this.jobService.getHoaProject(entityId, projectId).subscribe(
      (result) => {
        if (result) {
          this.projectDetails = result;
          this.projectDetailsLoaded = true;
          if (result.copilotDetails && result.copilotDetails.chat_details && result.copilotDetails.chat_details.length) {
            const latestChat = result.copilotDetails.chat_details[0];
            if (latestChat && latestChat.messages) {
              this.chatMessages = latestChat.messages.map(msg => ({
                text: msg.content,
                sender: msg.role === 'assistant' ? 'cora' : 'user'
              }));
            }
          }
        }
        this.fetchLeadsList(true, after);
      },
      (err) => {
        console.error('Error fetching project details:', err);
        this.fetchLeadsList(true, after);
      }
    );
  }

  /** Fetch leads via /hoaProjectLeads (used when parent did not supply apolloLeads). */
  private fetchLeadsList(reset: boolean, after?: () => void): void {
    const projectId = this.projectDetails && this.projectDetails.project_id;
    const entityId =
      (this.profile && this.profile.entity && this.profile.entity.id) ||
      (this.projectDetails && this.projectDetails.entity_id);
    if (!projectId) {
      this.isLoading = false;
      if (after) {
        after();
      }
      return;
    }

    const nextToken =
      !reset && this.pagination
        ? this.pagination.next_token || this.pagination.nextToken || null
        : null;

    // Totals come back null whenever name/mobile is set, so skip the count then.
    const filtered = this.isLeadsSearchActive();

    this.jobService
      .getHoaProjectLeads({
        projectId,
        pageSize: this.pageSize || 50,
        nextToken,
        order: 'desc',
        includeTotal: !filtered,
        entityId,
        name: this.leadsSearchName,
        mobile: this.leadsSearchMobile
      })
      .subscribe(
        (response) => {
          this.isLoading = false;
          const pageLeads = (response && response.leads) || [];
          const pagination = (response && response.pagination) || null;
          this.dataSource = reset ? pageLeads : (this.dataSource || []).concat(pageLeads);
          this.filteredDataSource = this.rankLeadsByScore(this.dataSource);
          this.pagination = pagination;
          this.apolloLeads = { leads: this.dataSource, pagination };
          this.leadsHasNextPage = !!(
            pagination &&
            (pagination.has_next_page === true || pagination.has_more === true) &&
            (pagination.next_token || pagination.nextToken)
          );

          if (this.dataSource && this.dataSource.length > 0) {
            const allScored = this.dataSource.every(function (lead) {
              return lead.total_score !== 'Calculating Score';
            });
            if (allScored) {
              this.coraState = 'finished';
            } else if (this.useApollo) {
              this.coraState = 'shortlisting';
            }
          } else {
            this.coraState = 'finished';
          }

          this.updateRange();
          this.pageNumbers = this.buildPageNumbers(this.getLeadsTotalPages(), this.getLeadsPageNum());
          this.projectDetailsLoaded = true;
          if (after) {
            after();
          }
        },
        (err) => {
          this.isLoading = false;
          const status = err && err.status;
          if (status === 400 && !reset) {
            // Invalid token — reset to first page
            this.pagination = null;
            this.fetchLeadsList(true, after);
            return;
          }
          console.error('Error fetching project leads:', err);
          this.projectDetailsLoaded = true;
          if (after) {
            after();
          }
        }
      );
  }

  /** Ask parent (or self) to hard-refresh leads after create/upload. */
  refreshLeadsList(): void {
    this.pageChange.emit({
      pageNum: 1,
      pageSize: this.getLeadsPageSize() || 50,
      reset: true
    });
    // Also self-fetch if parent does not handle the event
    if (!(this.apolloLeads && this.apolloLeads.leads && this.apolloLeads.leads.length)) {
      this.fetchLeadsList(true);
    }
  }

  private setLeadsPageNum(pageNum: number): void {
    if (!this.pagination) this.pagination = {};
    if (this.pagination.page_num != null) this.pagination.page_num = pageNum;
    else this.pagination.currentPageNum = pageNum;
    this.pageIndex = pageNum;
  }

  private setLeadsPageSize(pageSize: number): void {
    if (!this.pagination) this.pagination = {};
    if (this.pagination.items_per_page != null) this.pagination.items_per_page = pageSize;
    else this.pagination.currentPageSize = pageSize;
  }

  triggerParentPagination() {
    // Emit an event to parent or update apolloLeads directly (depending on your setup)
    console.log("Pagination triggered for page:", this.pageIndex);
  }

  // Fetch and set recording URL for the audio player
  openRecording(callSid: string) {
    console.log(callSid)
    // Stop current audio if a new row is clicked
    if (this.playingRecordingId && this.playingRecordingId !== callSid) {
      this.stopRecording();
    }

    // Toggle playback if the same row is clicked again
    if (this.playingRecordingId === callSid) {
      this.stopRecording();
      return;
    }

    // Fetch the recording URL and play
    this.twilioService.getCallRecordings(callSid)
      .then((mediaUrl: string | null) => {
        if (mediaUrl) {
          this.playRecording(callSid, mediaUrl);
        } else {
          console.log('No recordings found for this call');
        }
      })
      .catch(error => console.error('Error fetching recording:', error));
  }
  stopRecording() {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
      this.currentAudio = null;
      this.playingRecordingId = null;
      this.currentRecordingUrl = null;
    }
  }
  playRecording(callSid: string, audioUrl: string) {
    // If the same recording is clicked, toggle play/pause
    if (this.playingRecordingId === callSid && this.currentAudio) {
      if (this.currentAudio.paused) {
        this.currentAudio.play();
      } else {
        this.currentAudio.pause();
      }
      return;
    }

    // Stop current audio if a different row is clicked
    if (this.currentAudio && this.playingRecordingId !== callSid) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
    }

    // Create a new audio element for the selected recording
    this.currentAudio = new Audio(audioUrl);
    this.playingRecordingId = callSid;
    this.currentRecordingUrl = audioUrl;

    // Play the audio
    this.currentAudio.play();
  }

  openEmploymentModal(employmentHistory: any[]) {
    this.selectedEmploymentHistory = employmentHistory || [];
    this.showEmploymentModal = true;
  }

  closeEmploymentModal() {
    this.showEmploymentModal = false;
  }

  formatDate(dateString: string | null): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' }); // e.g., "Jun 2022"
  }

  /** Always show lead timestamps in Indian Standard Time (GMT+5:30). */
  private readonly leadDisplayTimeZone = 'Asia/Kolkata';

  /**
   * Resolve the best available date field on a lead / candidate record.
   * APIs return different shapes: unix seconds, ms, ISO, or YYYYMMDDHHmmss.
   */
  getLeadDateValue(lead: any): any {
    if (!lead) {
      return null;
    }
    return (
      lead.created_at ||
      lead.createdAt ||
      lead.created_on ||
      lead.added_at ||
      lead.updated_at ||
      lead.updatedAt ||
      lead.last_updated ||
      lead.start_time ||
      lead.timestamp ||
      null
    );
  }

  /**
   * Parse lead timestamps into a Date (absolute instant), or null if unparseable.
   * Handles unix sec/ms, ISO strings, and compact YYYYMMDDHHmmss (treated as IST wall time).
   */
  parseLeadDate(raw: any): Date | null {
    if (raw == null || raw === '') {
      return null;
    }

    // Already a human-formatted string (e.g. after formatStartTime) — try Date parse first
    if (typeof raw === 'string' && isNaN(Number(raw)) && raw.indexOf(',') !== -1) {
      const asDate = new Date(raw);
      if (!isNaN(asDate.getTime())) {
        return asDate;
      }
    }

    // Compact form: 20260730120052 (YYYYMMDDHHmmss).
    // Backend stores this as UTC wall-clock (not IST / not browser local).
    // Example: 20260730120052 = 12:00:52 UTC → 17:30:52 IST.
    const compact = String(raw).trim();
    if (/^\d{14}$/.test(compact)) {
      const y = Number(compact.slice(0, 4));
      const m = Number(compact.slice(4, 6)) - 1;
      const d = Number(compact.slice(6, 8));
      const hh = Number(compact.slice(8, 10));
      const mm = Number(compact.slice(10, 12));
      const ss = Number(compact.slice(12, 14));
      const date = new Date(Date.UTC(y, m, d, hh, mm, ss));
      if (!isNaN(date.getTime())) {
        const year = date.getUTCFullYear();
        if (year >= 2000 && year <= 2100) {
          return date;
        }
      }
    }

    // Numeric unix (seconds or milliseconds) — absolute UTC instant
    const num = typeof raw === 'number' ? raw : parseFloat(String(raw));
    if (Number.isFinite(num) && num > 0) {
      // 1e12 ≈ Sep 2001 in ms; below that treat as seconds
      const ms = num > 1e12 ? num : num * 1000;
      const date = new Date(ms);
      if (!isNaN(date.getTime())) {
        const year = date.getUTCFullYear();
        if (year >= 2000 && year <= 2100) {
          return date;
        }
      }
    }

    // ISO / other parseable strings (including trailing Z / offsets)
    if (typeof raw === 'string') {
      const date = new Date(raw);
      if (!isNaN(date.getTime())) {
        return date;
      }
    }

    return null;
  }

  /** Format a Date in IST (Asia/Kolkata). */
  private formatInIst(date: Date, options: Intl.DateTimeFormatOptions): string {
    if (!date) {
      return '';
    }
    return date.toLocaleString('en-GB', {
      timeZone: this.leadDisplayTimeZone,
      ...options
    });
  }

  /** Primary label for cards: "27 Jul 2026" (IST) */
  formatLeadDateDisplay(lead: any): string {
    const date = this.parseLeadDate(this.getLeadDateValue(lead));
    if (!date) {
      return '';
    }
    return this.formatInIst(date, {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  }

  /** Secondary time: "09:33 am" (IST) */
  formatLeadTimeDisplay(lead: any): string {
    const date = this.parseLeadDate(this.getLeadDateValue(lead));
    if (!date) {
      return '';
    }
    return this.formatInIst(date, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }

  /** Full tooltip: "27 Jul 2026, 09:33 am IST · 3 days ago" */
  formatLeadDateTooltip(lead: any): string {
    const date = this.parseLeadDate(this.getLeadDateValue(lead));
    if (!date) {
      return '';
    }
    const full = this.formatInIst(date, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }) + ' IST';
    const relative = this.formatRelativeTime(date);
    return relative ? full + ' · ' + relative : full;
  }

  formatRelativeTime(date: Date): string {
    if (!date) {
      return '';
    }
    const now = Date.now();
    const diffMs = now - date.getTime();
    if (!Number.isFinite(diffMs) || diffMs < 0) {
      return '';
    }
    const mins = Math.floor(diffMs / 60000);
    if (mins < 1) {
      return 'Just now';
    }
    if (mins < 60) {
      return mins + (mins === 1 ? ' min ago' : ' mins ago');
    }
    const hours = Math.floor(mins / 60);
    if (hours < 24) {
      return hours + (hours === 1 ? ' hour ago' : ' hours ago');
    }
    const days = Math.floor(hours / 24);
    if (days < 30) {
      return days + (days === 1 ? ' day ago' : ' days ago');
    }
    const months = Math.floor(days / 30);
    if (months < 12) {
      return months + (months === 1 ? ' month ago' : ' months ago');
    }
    const years = Math.floor(months / 12);
    return years + (years === 1 ? ' year ago' : ' years ago');
  }

  hasLeadDate(lead: any): boolean {
    return !!this.parseLeadDate(this.getLeadDateValue(lead));
  }

  getLeadRelativeLabel(lead: any): string {
    const date = this.parseLeadDate(this.getLeadDateValue(lead));
    return date ? this.formatRelativeTime(date) : '';
  }

  revealContact(type: 'phone' | 'email', call: any) {
    this.getCredits(type, call, 'revealContact');
  }

  // Updated revealContactNew: Mark both loading and revealed as true before API call to avoid race conditions
  revealContactNew(type: 'phone' | 'email', call: any) {
    const loadingKey = type === 'email' ? 'emailLoading' : 'phoneLoading';
    const revealedKey = type === 'email' ? 'emailRevealed' : 'phoneRevealed';

    if (call[loadingKey] || call[revealedKey]) return;

    // Immediately block both future clicks and visual toggle
    call[loadingKey] = true;
    call[revealedKey] = true;

    if (this.remainingCredits <= 0) {
      this.notify.showMessage(`Please topup your credits to reveal!`, 30000);
      return;
    }

    this.notify.showMessage(`Revealing ${type} for ${call.client_name}...`, 3000);

    const people_id = call.people_id;
    const project_id = call.project_id;

    if (!call.public_profiles.linkedin) {
      console.error('No LinkedIn URL available for this candidate.');
      return;
    }

    this.enterpriseAdminService.fetchCandidatePersonalDetailsHOA(
      call.public_profiles.linkedin,
      type,
      people_id,
      project_id,
      this.profile.entity.id
    ).subscribe(
      (response: any) => {
        this.reloadProjectMetadataThenLeads(() => {
          window.dispatchEvent(new Event('refreshCredits'));
        });
      },
      (error) => {
        this.notify.showMessage(
          `Failed to reveal ${type} for ${call.client_name}. Please try again.`,
          3000
        );
        console.error('Error fetching candidate details:', error);
      }
    );
  }
  openWorkflowPopup(details: any) {
    this.getCredits(details, null, 'openWorkflowPopup');
  }

  openWorkflowPopupNew(details: any) {
    if (this.remainingCredits <= 0) {
      this.notify.showMessage(
        `Please topup your credits to proceed!`,
        30000
      );
      return;
    } else {
      console.log(this.selection, this.projectDetails);
      this.workflowPopupData = [];
      if (this.selection && this.selection.selected.length) {
        this.selection.selected.forEach(element => {
          let obj = {
            "client_name": element.client_name,
            "client_email": element.client_email,
            "client_number": element.client_number,
            "entity_id": this.profile.entity.id,
            "project_id": this.projectDetails.project_id,
            "workflowType": "call"
          }
          this.workflowPopupData.push(obj);
        });

      } else {
        this.workflowPopupData = this.projectDetails;
      }

      if (this.projectDetails.final_prompt === undefined) {
        const dialogRef = this.dialog.open(WorkflowPopupComponent, {
          width: '640px',
          panelClass: 'add-edit-staff-dialog',
          disableClose: true,
          data: this.workflowPopupData
        });

        // Listen for the event from popup
        dialogRef.componentInstance.workflowSetup.subscribe((result) => {
          console.log("Workflow setup data:", result);

          // ✅ Store data in service before navigation
          this.workflowDataService.setWorkflowData(this.workflowPopupData);

          // Navigate to workflow-stepper page with project ID and workflow type query param
          const workflowType = (result && result.workflowType) ? result.workflowType : null;
          const navigationExtras = workflowType ? { queryParams: { workflowType: workflowType } } : {};
          this.router.navigate([`/job/view-new-project/${this.projectDetails.project_id}/setup-workflow`], navigationExtras);
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log("Popup closed");
        });
      } else {
        let obj = [{
          "client_name": details.client_name,
          "client_email": details.client_email,
          "client_number": details.client_number,
          "entity_id": this.profile.entity.id,
          "tts": "elevenlabs",
          "language": this.projectDetails.language || "en",
          "voice": this.projectDetails.voice || "male",
          "people_id": details.people_id,
        }]
        this.enterpriseAdminService.callSelectedUsers(this.projectDetails.agent_id, this.projectDetails.project_id, this.projectDetails.entity_id, obj).subscribe(res => {
          this.notify.showMessage(
            `Calling users...`,
            30000
          );
          // No empty status-polling interval
        }, (err => {
          console.log(err)
        }))
      }
    }
  }

  addUserManually() {
    const dialogRef = this.dialog.open(CreateLeadsUserComponent, {
      panelClass: 'create-lead-dialog',
      disableClose: true,
      autoFocus: true,
      width: '560px',
      maxWidth: '95vw',
      data: {
        project_id: this.projectDetails.project_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        this.isLoading = true;
        // Notify parent to refresh via /hoaProjectLeads, and self-fetch as backup
        this.pageChange.emit({
          pageNum: 1,
          pageSize: this.getLeadsPageSize() || 50,
          reset: true
        });
        this.reloadProjectMetadataThenLeads();
      }
    });
  }

  fetchMoreLeads(search_params = false) {
    this.coraState = 'searching';
    let body: any;
    if (search_params) {
      console.log("Go")
      body = {
        "project_id": this.projectDetails.project_id,
        "entity_id": this.projectDetails.entity_id,
        "project_description": this.projectDetails.project_description,
        "search_params": this.searchProjectName,
        "page": 1,
        "per_page": 2
      }
    } else {
      let parameters = this.projectDetails.apollo_filters;
      parameters.page = this.projectDetails.apollo_pagination.page + 1;
      body = {
        "project_id": this.projectDetails.project_id,
        "entity_id": this.projectDetails.entity_id,
        "apollo_parameters": parameters
      }
    }

    this.isLoading = true;
    this.enterpriseAdminService.fetchMoreCandidatesHOA(body).subscribe(
      (response: any) => {
        this.reloadProjectMetadataThenLeads(() => {
            this.coraState = 'shortlisting';
            // Identify leads with "Calculating Score"
            const leadsToScore = this.dataSource.filter(l => l.total_score === 'Calculating Score');
            if (leadsToScore.length > 0) {
              const icpProfile = this.projectDetails.icp_profile;
              for (let lead of leadsToScore) {
                const message = {
                  action: 'scoreLeads',
                  data: {
                    entity_id: this.projectDetails.entity_id,
                    project_id: this.projectDetails.project_id,
                    lead: lead,
                    icp_profile: icpProfile
                  }
                };
                this.wsService.send(message);
              }

              let attempts = 0;
              const maxAttempts = 6;
              const pollInterval = setInterval(() => {
                this.coraState = 'shortlisting';
                this.jobService.getHoaProjectLeads({
                  projectId: this.projectDetails.project_id,
                  pageSize: this.pageSize || 50,
                  order: 'desc',
                  entityId: this.profile.entity.id
                }).subscribe(
                  (refreshed) => {
                    const leads = (refreshed && refreshed.leads) || [];
                    const stillCalculating = leads.some(l => l.total_score === 'Calculating Score');
                    if (!stillCalculating || ++attempts >= maxAttempts) {
                      clearInterval(pollInterval);
                      this.dataSource = leads;
                      this.pagination = (refreshed && refreshed.pagination) || null;
                      this.apolloLeads = { leads: this.dataSource, pagination: this.pagination };
                      this.filteredDataSource = this.dataSource.sort((a, b) => (b.total_score || 0) - (a.total_score || 0));
                      this.isLoading = false;
                      this.coraState = 'finished';
                    }
                  },
                  () => {
                    clearInterval(pollInterval);
                    this.coraState = 'finished';
                    this.isLoading = false;
                  }
                );
              }, 4000);
            } else {
              this.filteredDataSource = this.dataSource.sort((a, b) => (b.total_score || 0) - (a.total_score || 0));
              this.isLoading = false;
            }
          });
      },
      (error) => {
        console.error('Error fetching candidate details:', error);
        this.isLoading = false;
      }
    );
  }

  importFromCSV() {
    const dialogRef = this.dialog.open(CallAgentComponent, {
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      autoFocus: true,
      minWidth: "500px",
      data: {
        projectId: this.projectDetails.project_id,
        showHeader: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        this.isLoading = true;
        this.refreshProjectDetailsAfterUpload();
        this.pageChange.emit({
          pageNum: 1,
          pageSize: this.getLeadsPageSize() || 50,
          reset: true
        });
        this.reloadProjectMetadataThenLeads();
      }
    });
  }

  searchLeads() {
    console.log("Search on")
  }

  clearSearch() {
    this.searchProjectName = "";
  }

  getInitials(name: string): string {
    if (!name) return "?"; // Fallback for missing names
    const nameParts = name.split(" ");
    let initials = nameParts[0] ? nameParts[0].charAt(0).toUpperCase() : "";

    if (nameParts.length > 1) {
      initials += nameParts[nameParts.length - 1].charAt(0).toUpperCase();
    }

    return initials;
  }

  // get Credits
  getCredits(type: any, call: any, functionName) {
    this.http.get(API_ACCOUNT_CREDIT + '/' + this.profile.entity.id).subscribe(
      (response: any) => {
        if (response) {
          // response.remainCredits = response.taskCredits - response.usedCredits;
          // this.credits = response;
          this.remainingCredits = response.taskCredits - response.usedCredits;
          console.log("Remaining credits", this.remainingCredits)
          if (functionName == 'openWorkflowPopup') {
            this.openWorkflowPopupNew(type);
          } else {
            this.revealContactNew(type, call);
          }
        }
      })
  }

  viewClientProfile(callDetails: any) {
    const dialogRef = this.dialog.open(ClientProfileComponent, {
      disableClose: true,
      width: '45%',
      height: '100vh',
      position: { right: '0', top: '0', bottom: '0' },
      panelClass: ['add-edit-role-dialog', 'client-profile-panel'],
      data: {
        projectDetails: this.projectDetails,
        projectId: this.projectDetails.project_id,
        callDetails: callDetails
      },
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        // this.isLoading = true;
        // this.jobService.getHoaProject(this.profile.entity.id, this.projectDetails.project_id).subscribe(
        //   (result) => {
        //     this.projectDetails = result;
        //     this.dataSource = result.leads;
        //     this.isLoading = false;
        //   })
      }
    });
  }

  runOutreach() {
    if (this.remainingCredits <= 0) {
      this.notify.showMessage(`Please topup your credits to proceed!`, 30000);
      return;
    } else {
      this.workflowPopupData = [];
      if (this.selection && this.selection.selected.length) {
        this.selection.selected.forEach(element => {
          let obj = {
            "client_name": element.client_name,
            "client_email": element.client_email,
            "client_number": element.client_number,
            "entity_id": this.profile.entity.id,
            "project_id": this.projectDetails.project_id,
            "workflowType": "call"
          }
          this.workflowPopupData.push(obj);
        });
      } else {
        this.workflowPopupData = this.projectDetails;
      }

      if (this.projectDetails.final_prompt === undefined) {
        const dialogRef = this.dialog.open(WorkflowPopupComponent, {
          width: '640px',
          panelClass: 'add-edit-staff-dialog',
          disableClose: true,
          data: this.workflowPopupData
        });

        dialogRef.componentInstance.workflowSetup.subscribe((result) => {
          console.log("Workflow setup data:", result);
          this.workflowDataService.setWorkflowData(this.workflowPopupData);
          // Navigate to workflow-stepper page with project ID and workflow type query param
          const workflowType = (result && result.workflowType) ? result.workflowType : null;
          const navigationExtras = workflowType ? { queryParams: { workflowType: workflowType } } : {};
          this.router.navigate([`/job/view-new-project/${this.projectDetails.project_id}/setup-workflow`], navigationExtras);
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log("Popup closed");
        });
      } else {
        const dialogRef = this.dialog.open(RunOutreachPopupComponent, {
          disableClose: true,
          width: '640px',
          data: {
            projectId: this.projectDetails.project_id,
            entityId: this.profile.entity.id,
            outcomes: this.projectDetails.expected_outcomes,
            useApollo: this.projectDetails.useApollo,
            workflow: this.projectDetails.workflow,
            autoScheduling: this.projectDetails.auto_scheduling,
            scheduleConfig: this.projectDetails.schedule_config,
            campaignConfig: this.projectDetails.campaign_config
          },
          autoFocus: true
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.changeTabTo === 'connected') {
            this.changeTab.emit('connected');
            this.workflowTabTriggered = result.workflowTabTriggered;
          }
        });
      }
    }
  }

  /**
   * Pause side of the Start/Pause AI-calling flip (button in the template
   * calls this instead of runOutreach() once process === 'In progress').
   * Mirrors ConnectedLeadsComponent.pauseWorkflow(): hoaWorkflowPause is the
   * primary action, then a best-effort editProjectTasks disable for leads
   * already at a terminal (goal) outcome.
   */
  pauseAiCalling() {
    const entityId = this.profile && this.profile.entity && this.profile.entity.id;
    const projectId = this.projectDetails && this.projectDetails.project_id;

    if (!entityId || !projectId) {
      this.notify.showMessage('Missing entity or project ID', 5000);
      return;
    }

    this.jobService.pauseWorkflow(entityId, projectId).subscribe(
      (res: any) => {
        this.notify.showMessage('Workflow paused successfully!', 5000);
        if (this.projectDetails.workflow) {
          this.projectDetails.workflow.process = 'Paused';
        }

        const goalOutcomes = this.projectDetails
          && this.projectDetails.campaign_config
          && Array.isArray(this.projectDetails.campaign_config.goal_outcomes)
          ? this.projectDetails.campaign_config.goal_outcomes
          : [];

        if (goalOutcomes.length) {
          this.jobService.editProjectTasks(
            entityId,
            projectId,
            'disable',
            goalOutcomes,
            'Disable tasks for terminal outcomes'
          ).subscribe(
            () => {
              // Silent success; pause is the primary action already confirmed above.
            },
            (err) => {
              console.error('editProjectTasks (disable terminal outcomes) error:', err);
              this.notify.showMessage(
                'Workflow paused, but failed to disable tasks for terminal-outcome leads',
                5000
              );
            }
          );
        }
      },
      (err) => {
        console.error('Pause workflow error:', err);
        const backendMessage =
          (err && err.error && err.error.message) || 'Failed to pause workflow due to unknown error';
        this.notify.showMessage(backendMessage, 5000);
      }
    );
  }

  startWhatsAppOutreach() {
    if (!this.projectDetails || !this.projectDetails.project_id) {
      this.notify.showMessage('Project details not available', 3000);
      return;
    }

    const projectId = this.projectDetails.project_id;
    const entityId = this.profile && this.profile.entity && this.profile.entity.id ? this.profile.entity.id : null;

    if (!entityId) {
      this.notify.showMessage('Entity ID not available', 3000);
      return;
    }

    // Default requiredLeads to 50, can be made configurable later
    const requiredLeads = 50;

    const payload = {
      projectId: projectId,
      entityId: entityId,
      requiredLeads: requiredLeads,
      process: 'start'
    };

    this.isLoading = true;
    this.enterpriseAdminService.startWhatsAppOutreach(payload).subscribe(
      (response: any) => {
        this.isLoading = false;
        const message = (response && (response.message || response.msg || response.status)) || 'WhatsApp AI outreach started successfully';
        this.notify.showMessage(message, 3000);
        // Optionally switch to connected tab
        this.changeTab.emit('connected');
      },
      (error: any) => {
        this.isLoading = false;
        const errorMessage = (error && error.error && (error.error.message || error.error.msg)) || 'Failed to start WhatsApp AI outreach. Please try again.';
        this.notify.showMessage(errorMessage, 5000);
        console.error('Error starting WhatsApp outreach:', error);
      }
    );
  }

  refreshProjectDetailsAfterUpload() {
    this.hideUploadUI = true; // 👈 Immediately hide upload UI
    this.showAgentStatus = true;
    this.coraState = 'parsing';
    this.shortlistedText = 'Cora is parsing the candidates';
  }

  startPollingForLeads() {
    console.log('🚀 startPollingForLeads triggered');
    this.showAgentStatus = true;
    this.coraState = 'parsing';
    this.shortlistedText = 'Cora is parsing the candidates';
  }

  pollForQueuedData() {
    this.queuePollingAttempts = 0;
    const prevCount = (this.dataSource && this.dataSource.length) || 0;

    this.queuePollingInterval = setInterval(() => {
      this.queuePollingAttempts++;
      console.log(`Polling attempt ${this.queuePollingAttempts}...`);

      const projectId = this.projectDetails && this.projectDetails.project_id;
      const entityId = this.profile && this.profile.entity && this.profile.entity.id;
      if (!projectId) {
        return;
      }

      this.jobService.getHoaProjectLeads({
        projectId,
        pageSize: this.pageSize || 50,
        order: 'desc',
        includeTotal: true,
        entityId
      }).subscribe(
        (response) => {
          const leads = (response && response.leads) || [];
          console.log(`Received leads on attempt ${this.queuePollingAttempts}`, leads.length, 'leads');

          if (leads.length > prevCount) {
            console.log('✅ New leads found! Updating dataSource and stopping polling.');
            clearInterval(this.queuePollingInterval);

            this.dataSource = leads;
            this.filteredDataSource = this.rankLeadsByScore(this.dataSource);
            this.pagination = (response && response.pagination) || null;
            this.apolloLeads = { leads: this.dataSource, pagination: this.pagination };

            if (this.selection) {
              this.selection.clear();
            }

            // Refresh project metadata without using embedded leads
            this.jobService.getHoaProject(entityId, projectId).subscribe(
              (meta) => { if (meta) { this.projectDetails = meta; } },
              () => undefined
            );

            // ✅ Update UI to Completed state
            this.shortlistedText = 'Cora is shortlisting the candidates';
            this.totalParsedLeads = this.dataSource.length;
            if (this.totalParsedLeads > 0) {
              this.completedText = `Cora has finished shortlisting.`;
              this.coraState = 'finished';
            } else {
              //this.completedText = `Unable to add leads.`;
            }
            this.showAgentStatus = true;
            this.updateRange();

          } else if (this.queuePollingAttempts >= this.maxQueuePollingAttempts) {
            console.log('❌ Max polling attempts reached without new leads. Stopping polling.');
            clearInterval(this.queuePollingInterval);

            // ✅ Timeout but still show Completed
            this.coraState = 'finished';
            this.shortlistedText = 'Cora is shortlisting the candidates';
            //this.completedText = `Unable to add leads.`;
            this.totalParsedLeads = this.dataSource.length;
            console.log('Total parsed leads:', this.totalParsedLeads);
            this.showAgentStatus = true;
          } else {
            // Continue polling if leads have not increased and attempts remain
            console.log('No new leads yet. Continuing to poll...');
          }
        },
        (error) => {
          console.error('Error fetching project data during polling:', error);
        }
      );
    }, 5000); // poll every 5 seconds
  }

  private handleQueuePollingComplete() {
    this.showAgentStatus = true;
    this.agentStatus = 'Completed';
    this.parsedLeadsCount = (this.dataSource && this.dataSource.length) || 0;
  }

  countHighMatchCandidates() {
    if (!this.dataSource || !this.dataSource.length) {
      return 0;
    }

    let highMatchCount = 0;
    for (let call of this.dataSource) {
      if (call && call.total_score && call.total_score > 80) {
        highMatchCount++;
      }
    }

    return highMatchCount;
  }

  /**
   * Server-side lead search (GET /hoaProjectLeads?name=&mobile=).
   * The single search box is routed to whichever param fits the term: anything
   * made only of phone characters goes to `mobile` (which matches fragments),
   * everything else to `name` (case-insensitive partial match).
   */
  filterCandidates() {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    this.searchDebounceTimer = setTimeout(() => {
      this.searchDebounceTimer = null;
      this.applyLeadsSearch();
    }, this.SEARCH_DEBOUNCE_MS);
  }

  clearLeadsSearch() {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
    this.searchText = '';
    this.applyLeadsSearch();
  }

  private applyLeadsSearch() {
    const term = (this.searchText || '').trim();
    const isPhoneLike = !!term && /^[0-9+][0-9+\-\s()]*$/.test(term);

    this.leadsSearchName = term && !isPhoneLike ? term : null;
    this.leadsSearchMobile = term && isPhoneLike ? term : null;

    this.leadsSearch.emit({ name: this.leadsSearchName, mobile: this.leadsSearchMobile });

    // When this component owns the fetch (parent did not supply apolloLeads),
    // drive the refetch ourselves.
    if (!this.apolloLeads) {
      this.pagination = null;
      this.isLoading = true;
      this.fetchLeadsList(true);
    }
  }

  isLeadsSearchActive(): boolean {
    return !!(this.leadsSearchName || this.leadsSearchMobile);
  }

  adjustICP() {
    const dialogRef = this.dialog.open(AdjustIcpComponent, {
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      autoFocus: true,
      width: "600px",
      data: {
        projectId: this.projectDetails.project_id,
        entityId: this.profile.entity.id,
        icpProfile: this.projectDetails.icp_profile,
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result && result.triggerUpdate) {
        this.coraState = 'searching';
        this.disableBtn = true;
        this.jobService.updateICP(result.entityId, result.projectId, result.icpProfile).subscribe(
          (res) => {
            this.reloadProjectMetadataThenLeads(() => {
                this.coraState = 'shortlisting';
                this.sendLeadsForScoring();
                this.disableBtn = false;
            });
          },
          (err) => {
            console.error('❌ Failed to update ICP', err);
            this.disableBtn = false;
          }
        );
      }
    });
  }
  sendLeadsForScoring() {
    if (!this.projectDetails || !this.projectDetails.icp_profile || !this.dataSource || !this.dataSource.length) {
      console.error("Missing ICP profile or leads data");
      return;
    }

    const icpProfile = this.projectDetails.icp_profile;
    const leads = this.dataSource;

    for (let lead of leads) {
      const message = {
        action: 'scoreLeads',
        data: {
          entity_id: this.projectDetails.entity_id,
          project_id: this.projectDetails.project_id,
          lead: lead,
          icp_profile: icpProfile
        }
      };

      //console.log('📤 Sending WebSocket message:', message);
      try {
        this.wsService.send(message);
      } catch (err) {
        console.error("Failed to send lead via WebSocket:", err);
      }
    }

    this.wsService.messages$.subscribe((response) => {
      //console.log("📩 WebSocket response received:", response);

      if (response && response.lead && response.lead.people_id) {
        const updatedLead = response.lead;
        const index = this.dataSource.findIndex(lead => lead.people_id === updatedLead.people_id);
        if (index !== -1) {
          this.dataSource[index] = updatedLead;
        }

        const filteredIndex = this.filteredDataSource.findIndex(lead => lead.people_id === updatedLead.people_id);
        if (filteredIndex !== -1) {
          this.filteredDataSource[filteredIndex] = updatedLead;
        }
      }
    });
  }

  getBreakdownKeys(leadScore: any): string[] {
    return Object.keys(leadScore || {}).filter(k => k !== 'final_score');
  }

  /**
   * Creates a new project when navigated here with raw payload and attachments in history.state
   */
  createProject() {
    const state = history.state;
    console.log("History state:", state);
    console.log("Agent type from state:", state.agentType);
    // Insert Apollo flow state logic
    this.coraState = state.coraState || 'searching';
    this.hideUploadUI = state.useApollo ? true : false;
    this.wsService.connect(API_WEB_SOCKET);
    if (state && state.createProjectPayloadRaw) {
      const raw = state.createProjectPayloadRaw;
      const attachments: File[] = state.attachments || [];
      const formData = new FormData();

      // Add agentType to raw object if coming from inbound calling card
      if (state.agentType === 'inbound') {
        console.log("Adding agentType: inbound to payload");
        raw.agentType = 'inbound';
      }

      // Append raw fields
      for (let key in raw) {
        if (raw.hasOwnProperty(key)) {
          formData.append(key, raw[key]);
        }
      }
      // Append attachments if any
      attachments.forEach((file: File, idx: number) => {
        formData.append(`attachments[${idx}]`, file);
      });

      this.isLoading = true;

      // Create project
      this.jobService.createHoaProject(formData).subscribe(
        (result: any) => {
          console.log("✅ Project created successfully:", result);
          this.notify.showMessage("Project created successfully!", 3000);
          // Post-create update: persist additional fields from clone payload using same APIs as workflow stepper
          try {
            var postState = state && state.createProjectPayloadRaw ? state.createProjectPayloadRaw : null;
            var createdProjectId = (result && (result.project_id || result.id)) ? (result.project_id || result.id) : (postState && postState.projectId ? postState.projectId : null);
            if (postState && createdProjectId) {
              // A) Update HOA project (FormData)
              var hoaUpdate = new FormData();
              hoaUpdate.append('entityId', this.profile.entity.id);
              hoaUpdate.append('userId', this.profile.user.id);
              hoaUpdate.append('userName', this.profile.user.userMeta.name);
              hoaUpdate.append('projectId', createdProjectId);
              if (postState.agentId) hoaUpdate.append('agentId', postState.agentId);
              if (postState.agentName) hoaUpdate.append('agentName', postState.agentName);
              if (postState.language) hoaUpdate.append('language', postState.language);
              if (postState.voice) hoaUpdate.append('voice', postState.voice);
              if (postState.tts) hoaUpdate.append('tts', postState.tts);
              if (postState.plivo_caller_id) hoaUpdate.append('plivoCallerId', postState.plivo_caller_id);
              if (postState.auto_call !== undefined && postState.auto_call !== null) hoaUpdate.append('autoCall', postState.auto_call ? 'true' : 'false');
              if (postState.website_link) hoaUpdate.append('websiteLink', postState.website_link);
              if (postState.transfer_number) hoaUpdate.append('transferNumber', postState.transfer_number);
              if (postState.user_prompt) hoaUpdate.append('userPrompt', postState.user_prompt);
              if (postState.user_questions) {
                var uq = postState.user_questions;
                hoaUpdate.append('userQuestions', (typeof uq === 'string') ? uq : JSON.stringify(uq));
              }
              if (postState.user_variables) {
                var uv = postState.user_variables;
                hoaUpdate.append('userVariables', (typeof uv === 'string') ? uv : JSON.stringify(uv));
              }
              if (postState.agentType) {
                hoaUpdate.append('agentType', postState.agentType);
              }
              this.jobService.updateHoaProject(hoaUpdate).subscribe(function () { }, function (e) { console.warn('updateHoaProject post-create failed', e); });

              // B) Update outcomes / final prompt via JSON API
              var updatePayload = {
                entityId: this.profile.entity.id,
                userId: this.profile.user.id,
                userName: this.profile.user.userMeta.name,
                projectId: createdProjectId
              } as any;
              if (postState.final_prompt) updatePayload.finalPrompt = postState.final_prompt;
              if (postState.expected_outcomes) updatePayload.expectedOutcomes = postState.expected_outcomes;
              if (updatePayload.finalPrompt || updatePayload.expectedOutcomes) {
                this.jobService.updateProject(updatePayload).subscribe(function () { }, function (e) { console.warn('updateProject post-create failed', e); });
              }
            }
          } catch (e) {
            console.warn('Post-create update failed', e);
          }

          // Navigate to setup-workflow directly for inbound projects
          if (state.agentType === 'inbound') {
            this.router.navigate([`/job/view-new-project/${state.createProjectPayloadRaw.projectId}/setup-workflow`]);
          } else {
            this.router.navigate([`/job/view-new-project/${state.createProjectPayloadRaw.projectId}`]);
          }

          // Immediately fetch full project details (metadata) + leads from /hoaProjectLeads
          this.jobService.getHoaProject(this.profile.entity.id, result.project_id || result.id).subscribe(
            (proj) => {
              this.projectDetails = proj;

              // Update chat messages from copilotDetails if available
              if (
                proj &&
                proj.copilotDetails &&
                proj.copilotDetails.chat_details &&
                proj.copilotDetails.chat_details.length > 0
              ) {
                const latestChat = proj.copilotDetails.chat_details.find(chat => chat.active);
                if (latestChat && latestChat.messages && latestChat.messages.length > 0) {
                  this.chatMessages = latestChat.messages.map(msg => ({
                    text: msg.content,
                    sender: msg.role === 'assistant' ? 'cora' : 'user'
                  }));
                }
              }

              this.jobService['currentProjectName'] = proj.project_name;
              this.projectDetailsLoaded = true;

              this.fetchLeadsList(true, () => {
                // New logic: handle Apollo vs non-Apollo flow and coraState
                const needsScoring = this.dataSource.some(lead => lead.total_score === 'Calculating Score');

                if (needsScoring) {
                  this.coraState = 'shortlisting';
                  this.sendLeadsForScoringViaWS();
                } else {
                  this.coraState = 'finished';
                }
              });
            },
            (err) => {
              console.error("Error fetching project after creation:", err);
              this.isLoading = false;
            }
          );
        },
        (error: any) => {
          setTimeout(() => {
            const trialDialogRef = this.dialog.open(TrialEndedPopupComponent, {
              width: '640px',
              disableClose: true,
              data: {
                subscriptionStatus: 'TRIAL_EXPIRED',
                //subscriptionPlanName: res.subscriptionPlanName,
              }
            });
            trialDialogRef.afterClosed().subscribe((result) => {
              if (result === true) {
                this.openUpgradePopup();
              }
            });
          }, 100);
          setTimeout(() => {
            this.router.navigate(['/dashboard']);
          }, 100);
          this.isLoading = false;
          this.coraState = null;
        }
      );
    }
  }
  openUpgradePopup() {
    const dialogRef = this.dialog.open(UpgradeSubscriptionPopupComponent, {
      panelClass: 'upgrade-subscription-popup',
      disableClose: true,
      width: '100%',
      maxWidth: '100%',
      data: {
        //"currentPlan": this.currentUserSubscription,
        // "isTrial": this.currentUserSubscription && this.currentUserSubscription.subscriptionStatus === 'TRIAL',
        // "isPaid": this.currentUserSubscription && this.currentUserSubscription.subscriptionStatus === 'ACTIVE',
        // "isFree": this.currentUserSubscription && this.currentUserSubscription.subscriptionStatus === 'FREE'
      },
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      //this.refreshPage();

    });
  }

  //     refreshPage() {
  //   this.fetchRechargeRequests();
  //   if (this.profile.entity.entityType === 'ENTERPRISE' || this.profile.entity.entityType === 'AGENCY'
  //     || this.profile.entity.entityType === 'AGENT'
  //   ) {
  //     this.fetchWalletBalance();
  //     this.fetchTaskCredits();
  //     this.getCurrentUserSubscription();
  //     this.creditsService.setRefreshCreditsHeader(true);
  //   }
  // }
  onUploadComplete() {
    this.hideUploadUI = true;
  }
  // Removed startPollingForLeads since upload success is now handled via WebSocket confirmation.
  /**
   * Sorts the given array of leads by total_score in descending order.
   * Handles missing or non-numeric scores gracefully.
   */
  rankLeadsByScore(leads: any[]): any[] {
    if (!leads || !Array.isArray(leads)) return [];

    return leads.sort(function (a, b) {
      const scoreA = a.total_score ? parseFloat(a.total_score) : 0;
      const scoreB = b.total_score ? parseFloat(b.total_score) : 0;
      return scoreB - scoreA; // Descending order
    });
  }

  downloadCandidatesDate(): void {
    const entityId = this.profile.entity.id;
    const projectId = this.projectDetails.project_id;

    if (!entityId || !projectId) {
      this.notify.showMessage('Missing entity or project ID.', 2000);
      return;
    }

    const url = `${DOWNLOAD_LEADS_EXCEL}?entity_id=${entityId}&project_id=${projectId}`;

    const headers = {
      'x-api-key': environment.projectAPIKey
    };

    this.http.get(url, { headers, responseType: 'blob', observe: 'response' })
      .subscribe((response: HttpResponse<Blob>) => {
        const blob = new Blob([response.body!], { type: 'application/octet-stream' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = 'candidates_data.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
      }, error => {
        console.error('Export failed:', error);
        this.notify.showMessage('Export failed. Please try again.', 2000);
      });
  }

  copyShareableLink() {
    const url = environment.production
      ? `https://apply.houseofagents.ai/?project_id=${this.projectDetails.project_id}&entity_id=${this.profile.entity.id}`
      : `https://apply-dev.houseofagents.ai/?project_id=${this.projectDetails.project_id}&entity_id=${this.profile.entity.id}`;

    navigator.clipboard.writeText(url).then(() => {
      console.log('Link copied:', url);
      this.notify.showMessage(
        "Link copied",
        5000,
        'assets/tick-circle.svg',
        `Share URL with leads to allow them to submit resume!`
      );
    }).catch(err => {
      console.error('Failed to copy link:', err);
    });
  }

  sendEmail() {
    console.log(this.selection, this.projectDetails)

    if (!this.selection || !this.selection.selected.length) return;

    const emailObj = this.selection.selected.map(candidate => ({
      client_email: candidate.client_email,
      client_name: candidate.client_name,
      client_id: candidate.people_id,
      projectId: this.projectDetails.project_id
    }));

    console.log('Selected Email Payload:', emailObj);

    // Open Google popup and pass emailObj
    this.handleEmailFlowWithGoogleAccount(emailObj, this.profile.entity.id, this.projectDetails.project_id);
  }

  async handleEmailFlowWithGoogleAccount(
    emailObj: { client_email: string; client_name: string }[],
    entityId: string,
    projectId: string
  ) {
    try {
      this.isLoading = true;

      const userTokens = await this.fetchUserTokens(this.profile.user.id);

      if (userTokens.length > 0) {
        this.existingAccounts = userTokens;
        const dialogRef = this.dialog.open(GoogleAccountPopupComponent, {
          panelClass: 'add-edit-staff-dialog',
          disableClose: true,
          autoFocus: true,
          width: "400px",
          data: {
            existingAccounts: this.existingAccounts,
            projectId
          }
        });

        dialogRef.afterClosed().subscribe(async (result) => {
          if (result && typeof result === 'object') {
            await this.selectExistingAccount(result);
            await this.sendInitialEmail(emailObj, result.googleRefreshToken);
          } else if (result) {
            const tokenData = await this.linkNewAccount();
            if (tokenData.refreshToken) {
              await this.sendInitialEmail(emailObj, tokenData.refreshToken);
            }
          }
          this.isLoading = false;
        });
      } else {
        const tokenData = await this.linkNewAccount();
        if (tokenData.refreshToken) {
          await this.sendInitialEmail(emailObj, tokenData.refreshToken);
        }
      }
    } catch (error) {
      console.error('Error during email account linking:', error);
      this.isLoading = false;
      this.notify.showMessage('Error checking existing accounts!', 2000);
    }
  }

  private async fetchUserTokens(userId: string): Promise<UserToken[]> {
    try {
      const response = await this.http.get<UserToken[]>(API_AUTH + `/v1/user-tokens/${userId}`).toPromise();
      return response || [];
    } catch (error) {
      console.error('Error fetching user tokens:', error);
      throw error;
    }
  }

  async selectExistingAccount(account: UserToken) {
    try {
      const projectData = {
        entityId: this.profile.entity.id,
        userId: this.profile.user.id,
        userName: this.profile.user.userMeta.name,
        projectId: this.projectDetails.project_id,
        gmailRefreshToken: account.googleRefreshToken,
      };

      await this.jobService.updateProject(projectData).toPromise();
      this.notify.showMessage('Google account linked successfully!', 2000);
    } catch (err) {
      console.error('Error linking existing account:', err);
      this.notify.showMessage('Error while linking gmail account!', 2000);
    }
  }

  async linkNewAccount(): Promise<{ refreshToken: string } | null> {
    const authInstance = gapi.auth2.getAuthInstance();

    try {
      const response = await authInstance.grantOfflineAccess({ prompt: 'consent' });
      const authCode = response.code;

      const event = await this.http.post<{ idToken: string, refreshToken: string, email: string }>(
        API_AUTH + '/v1/google/exchange-token',
        { code: authCode, allowFreeDomain: true }
      ).toPromise();

      if (event && event.refreshToken) {
        this.saveRefreshToken(this.profile.user.id, event.email, event.refreshToken);

        const projectData = {
          entityId: this.profile.entity.id,
          userId: this.profile.user.id,
          userName: this.profile.user.userMeta.name,
          projectId: this.projectDetails.project_id,
          gmailRefreshToken: event.refreshToken,
        };

        await this.jobService.updateProject(projectData).toPromise();

        this.notify.showMessage('Google account linked successfully!', 2000);
        return { refreshToken: event.refreshToken };
      } else {
        throw new Error('Refresh token not received');
      }
    } catch (error) {
      console.error('Error linking new account:', error);
      this.notify.showMessage('Error while linking gmail account!', 2000);
    }
  }

  saveRefreshToken(userId: string, email: string, refreshToken: string): void {
    const userTokenDto = { userId, email, googleRefreshToken: refreshToken };
    const authToken = localStorage.getItem("jwtToken");

    const headers = new HttpHeaders({
      'Authorization': '${authToken}',
      'Content-Type': 'application/json'
    });

    this.http.post(API_AUTH + '/v1/user-tokens/save', userTokenDto, { headers })
      .subscribe({
        next: () => console.log("Refresh token stored successfully!"),
        error: (err) => console.error("Failed to store refresh token:", err)
      });
  }

  async sendInitialEmail(
    emailObj: { client_email: string, client_name: string }[],
    refreshToken: string
  ) {
    const entityId = this.profile.entity.id;
    const projectId = this.projectDetails.project_id;

    try {
      // Step 1: Fetch the initial email template
      const template = await this.jobService
        .getHoaProjectInitialEmailTemplate(entityId, projectId)
        .toPromise();

      console.log('Email template:', template);

      // Step 2: Send email using jobService
      await this.jobService
        .sendEmail(emailObj, entityId, projectId, refreshToken)
        .toPromise();

      this.notify.showMessage('Email sent successfully!', 2000);
      this.selection.clear();
    } catch (error) {
      console.error('Error in sendInitialEmail:', error);
      this.notify.showMessage('Failed to send email.', 2000);
    }
  }

  testAgent() {
    console.log('Project Details:', this.projectDetails);
    console.log('Profile:', this.profile);

    // Log all available properties in projectDetails
    if (this.projectDetails) {
      console.log('Available properties in projectDetails:');
      Object.keys(this.projectDetails).forEach(key => {
        console.log(`${key}:`, this.projectDetails[key]);
      });
    }

    // Try to get client info from different possible sources
    const clientName = this.projectDetails && (
      this.projectDetails.client_name ||
      this.projectDetails.clientName ||
      this.projectDetails.name ||
      'Test Client'
    );

    const clientEmail = this.projectDetails && (
      this.projectDetails.client_email ||
      this.projectDetails.clientEmail ||
      this.projectDetails.email ||
      'test@example.com'
    );

    const clientNumber = this.projectDetails && (
      this.projectDetails.client_number ||
      this.projectDetails.clientNumber ||
      this.projectDetails.phone ||
      '+1234567890'
    );

    const dialogData = {
      projectId: this.projectDetails && this.projectDetails.project_id,
      entityId: this.profile && this.profile.entity && this.profile.entity.id,
      agentId: this.projectDetails && this.projectDetails.agent_id,
      clientName: clientName,
      clientEmail: clientEmail,
      clientNumber: clientNumber,
      tts: this.projectDetails && this.projectDetails.tts || "elevenlabs",
      language: this.projectDetails && this.projectDetails.language || "en",
      voice: this.projectDetails && this.projectDetails.voice || "male",
      customParams: this.projectDetails && this.projectDetails.custom_params || {},
      // Optional: if backend attaches a direct VocalLabs WS URL, the dialog can use it.
      callProvider: this.projectDetails && (this.projectDetails.vocallabs_ws_url || this.projectDetails.vocallabsWsUrl) ? 'vocallabs' : 'pipecat',
      vocallabsWsUrl: this.projectDetails && (this.projectDetails.vocallabs_ws_url || this.projectDetails.vocallabsWsUrl) || null
    };

    console.log('Dialog Data being passed:', dialogData);

    const dialogRef = this.dialog.open(TestAgentDialogComponent, {
      width: '600px',
      height: '500px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: false,
      autoFocus: true,
      data: dialogData
    });

    dialogRef.afterOpened().subscribe(() => {
      console.log('Test Agent dialog opened successfully');
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Test Agent dialog closed:', result);
    });
  }

  openTrainAIDialog() {
    console.log("train agent")
  }

  private autoOpenWabaTried = false;
  /** Poll briefly until projectDetails has loaded, then open the WABA dialog once. */
  private autoOpenWabaDialog(attempt: number = 0): void {
    if (this.autoOpenWabaTried) { return; }
    if (this.projectDetails && this.projectDetails.project_id) {
      this.autoOpenWabaTried = true;
      setTimeout(() => this.openWABAConnectDialog(), 300);
      return;
    }
    if (attempt >= 20) { return; } // ~8s max wait for the project to load
    setTimeout(() => this.autoOpenWabaDialog(attempt + 1), 400);
  }

  openWABAConnectDialog() {
    const projectId = this.projectDetails && this.projectDetails.project_id;
    if (!projectId) {
      console.error('No project ID available');
      this.notify.showMessage('Project ID not found.', 2000);
      return;
    }

    const entityId = this.profile && this.profile.entity && this.profile.entity.id;
    const whatsappVendor = this.projectDetails ? (this.projectDetails as any).whatsapp_vendor : null;
    const whatsappPhoneNumber = this.projectDetails ? (this.projectDetails as any).whatsapp_phone_number : null;
    const dialogData = {
      entity_id: entityId,
      project_id: projectId,
      whatsapp_vendor: whatsappVendor,
      whatsapp_phone_number: whatsappPhoneNumber
    };

    const dialogRef = this.dialog.open(WABAConnectDialogComponent, {
      width: '600px',
      maxHeight: '80vh',
      panelClass: 'add-edit-staff-dialog',
      disableClose: false,
      autoFocus: true,
      data: dialogData
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.action === 'whatsapp_bridge') {
        this.authenticateWhatsapp();
        return;
      }
      if (result && result.success) {
        console.log('WhatsApp connected successfully:', result);
        this.notify.showMessage(result.message || 'WhatsApp connected to project successfully!', 3000);
        // Refresh project details to show updated whatsapp_provider_type
        if (this.projectDetails && this.projectDetails.project_id) {
          this.refreshProjectDetails();
        }
      }
    });
  }

  refreshProjectDetails() {
    if (!this.projectDetails || !this.projectDetails.project_id) {
      return;
    }

    this.jobService.getHoaProject(this.profile.entity.id, this.projectDetails.project_id).subscribe(
      (result) => {
        this.projectDetails = result;
        // Also refresh WhatsApp status if needed
        if (this.projectDetails && this.projectDetails.project_id) {
          this.checkWhatsAppStatus();
        }
      },
      (err) => {
        console.error('Error refreshing project details:', err);
      }
    );
  }

  authenticateWhatsapp() {
    const projectId = this.projectDetails.project_id;
    if (!projectId) {
      console.error('No project ID available');
      return;
    }

    const body = {
      entity_id: this.profile.entity.id,
      project_id: projectId,
      project_name: this.projectDetails.project_name || 'Your Project Name'
    };

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    console.log('Creating WhatsApp session:', body);

    // Step 1: Create session
    this.http.post<WhatsAppResponse>(API_WHATSAPP_SESSION, body, { headers, observe: 'response' }).subscribe({
      next: (response) => {
        console.log('Session created - Response:', response.body);
        this.whatsappResponse = response.body;

        // Step 2: After session is created, fetch QR code
        if (response.body) {
          this.whatsappSessionId = response.body.session_id || projectId;
          // QR may need a moment after session creation. Fetch with bounded
          // retries instead of a single blind 5s wait (which silently failed
          // and showed "Failed to fetch QR code" when init took longer).
          this.qrFetchAttempts = 0;
          setTimeout(() => {
            this.fetchWhatsAppQR();
          }, 1500);
        } else {
          this.notify.showMessage('Session created but no response received', 2000);
        }
      },
      error: (err) => {
        console.error('Error creating WhatsApp session:', err);
        this.notify.showMessage('Failed to create WhatsApp session', 2000);
      }
    });
  }

  fetchWhatsAppQR() {
    const projectId = this.projectDetails.project_id;
    if (!projectId) {
      console.error('No project ID available for QR fetch');
      return;
    }

    const params = new URLSearchParams({
      project_id: projectId,
      entity_id: this.profile.entity.id
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true',
      'Accept': 'image/png,image/*,*/*'
    });

    console.log('Fetching WhatsApp QR code...');

    // Step 3: Fetch QR code (binary PNG image) and display in popup
    this.http.get(`${API_WHATSAPP_QR}?${params.toString()}`, {
      headers,
      responseType: 'blob'
    }).subscribe({
      next: (response: Blob) => {
        console.log('QR Code response received:', response);
        console.log('Blob size:', response.size, 'Blob type:', response.type);

        // Create a new blob with explicit PNG type
        const pngBlob = new Blob([response], { type: 'image/png' });

        // Create object URL from blob
        const blobUrl = URL.createObjectURL(pngBlob);
        console.log('Created blob URL:', blobUrl);

        // Sanitize the blob URL for Angular
        this.qrCodeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);

        // Show the popup with QR code
        this.showWhatsappQRPopup = true;
        this.qrFetchAttempts = 0;

        // Start polling for connection status
        this.startStatusPolling();
      },
      error: (err) => {
        // The QR can lag the session by a few seconds. Retry a bounded number
        // of times before surfacing an error, instead of failing on first miss.
        this.qrFetchAttempts++;
        if (this.qrFetchAttempts < this.QR_FETCH_MAX_ATTEMPTS) {
          console.warn(`QR not ready yet (attempt ${this.qrFetchAttempts}/${this.QR_FETCH_MAX_ATTEMPTS}); retrying...`);
          setTimeout(() => this.fetchWhatsAppQR(), 1500);
          return;
        }
        console.error('Error fetching QR code:', err);
        this.notify.showMessage('Could not load the WhatsApp QR code. Please close and try again.', 3000);
      }
    });
  }

  showWhatsappQRDialog() {
    this.showWhatsappQRPopup = true;
  }

  onQRImageError(event: any) {
    console.error('Error loading QR code image:', event);
    this.notify.showMessage('Failed to load QR code image', 2000);
  }

  onQRImageLoad() {
    console.log('QR code image loaded successfully');
  }

  closeWhatsappQRDialog() {
    this.showWhatsappQRPopup = false;
    // Revoke object URL to prevent memory leaks
    let urlString: string = '';
    if (typeof this.qrCodeUrl === 'string') {
      urlString = this.qrCodeUrl;
    } else if (this.qrCodeUrl) {
      urlString = (this.qrCodeUrl as any).changingThisBreaksApplicationSecurity || '';
    }
    if (urlString && urlString.startsWith('blob:')) {
      URL.revokeObjectURL(urlString);
    }
    this.qrCodeUrl = '';
    this.whatsappSessionId = '';
    this.stopStatusPolling();
  }

  sendWhatsAppViaAgent() {
    // Check if exactly one lead is selected
    if (!this.selection.hasValue() || this.selection.selected.length !== 1) {
      this.notify.showMessage('Please select exactly one lead for WhatsApp messaging', 2000);
      return;
    }

    const selectedLead = this.selection.selected[0];
    const projectId = this.projectDetails.project_id;
    const peopleId = selectedLead.people_id;

    if (!projectId || !peopleId) {
      this.notify.showMessage('Missing project ID or lead ID', 2000);
      return;
    }

    // Find image_url from WhatsApp actions in project outcomes
    let imageUrl = '';
    if (this.projectDetails && this.projectDetails.expected_outcomes && Array.isArray(this.projectDetails.expected_outcomes)) {
      for (const outcome of this.projectDetails.expected_outcomes) {
        if (outcome.callActions && Array.isArray(outcome.callActions)) {
          for (const action of outcome.callActions) {
            if (action.call_action === 'Send WhatsApp Message' && action.image_url) {
              imageUrl = action.image_url;
              break;
            }
          }
          if (imageUrl) break;
        }
      }
    }

    const params = new URLSearchParams({
      project_id: projectId,
      entity_id: this.profile.entity.id,
      people_id: peopleId
    });

    // Add image_url to query parameters if it exists
    if (imageUrl) {
      params.append('image_url', imageUrl);
    }

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const url = `${API_WHATSAPP_AGENT_SEND}?${params.toString()}`;
    console.log('Making WhatsApp request to:', url);

    this.http.get(url, { headers, observe: 'response' }).subscribe({
      next: (response) => {
        console.log('WhatsApp message sent successfully:', response.body);
        this.notify.showMessage('WhatsApp message initiated successfully!', 2000);
      },
      error: (err) => {
        console.error('Error sending WhatsApp message:', err);
        this.notify.showMessage('Failed to send WhatsApp message', 2000);
      }
    });
  }

  checkWhatsAppStatus(projectId?: string) {
    console.log("checkWhatsAppStatus")
    const id = projectId || (this.projectDetails && this.projectDetails.project_id);
    if (!id) {
      console.log('No project ID available for WhatsApp status check');
      return;
    }

    const params = new URLSearchParams({
      project_id: id,
      entity_id: this.profile.entity.id
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const statusUrl = `${API_WHATSAPP_STATUS}?${params.toString()}`;
    console.log('statusUrl', statusUrl)

    this.http.get(statusUrl, { headers }).subscribe({
      next: (response: any) => {
        console.log('WhatsApp status response:', response);
        this.whatsappStatus = response;

        // Handle new API response format: response.data.data.authenticated and health.status
        if (response && response.data && response.data.data) {
          const statusData = response.data.data;
          // Check both authenticated flag AND health status (both must be true)
          const isAuthenticated = statusData.authenticated === true;
          const isHealthConnected = statusData.health && statusData.health.status === 'connected';
          this.isWhatsappConnected = isAuthenticated && isHealthConnected;
          // Store phone number if available (might be in different location)
          if (statusData.phone) {
            this.whatsappStatus.phone = statusData.phone;
          }
        } else {
          // Fallback for old format
          this.isWhatsappConnected = response && (
            (response.status === 'authenticated') ||
            (response.authenticated === 1) ||
            (response.authenticated === true)
          );
        }
      },
      error: (err) => {
        console.error('Status check failed:', err);
        this.isWhatsappConnected = false;
      }
    });
  }

  startStatusPolling() {
    console.log('Starting WhatsApp status polling...');
    this.whatsappPollAttempts = 0;
    this.stopStatusPolling(); // guard against duplicate intervals
    this.whatsappStatusInterval = setInterval(() => {
      // Hard cap so polling never leaks forever if the user never scans / closes.
      this.whatsappPollAttempts++;
      if (this.whatsappPollAttempts > this.WHATSAPP_POLL_MAX_ATTEMPTS) {
        console.warn('WhatsApp status polling timed out after max attempts.');
        this.stopStatusPolling();
        if (!this.isWhatsappConnected) {
          this.notify.showMessage('QR code expired. Please close and reconnect.', 3000);
          this.showWhatsappQRPopup = false;
        }
        return;
      }
      this.pollWhatsAppStatus();
    }, 3000); // Poll every 3 seconds
  }

  stopStatusPolling() {
    if (this.whatsappStatusInterval) {
      console.log('Stopping WhatsApp status polling...');
      clearInterval(this.whatsappStatusInterval);
      this.whatsappStatusInterval = null;
    }
  }

  pollWhatsAppStatus() {
    const projectId = this.route.snapshot.params['id'] || (this.projectDetails && this.projectDetails.project_id);
    if (!projectId) return;

    const params = new URLSearchParams({
      project_id: projectId,
      entity_id: this.profile.entity.id
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const statusUrl = `${API_WHATSAPP_STATUS}?${params.toString()}`;

    this.http.get(statusUrl, { headers }).subscribe({
      next: (response: any) => {
        console.log('Polling - WhatsApp status:', response);
        this.whatsappStatus = response;
        const wasConnected = this.isWhatsappConnected;

        // Handle new API response format: response.data.data.authenticated and health.status
        if (response && response.data && response.data.data) {
          const statusData = response.data.data;
          // Check both authenticated flag AND health status (both must be true)
          const isAuthenticated = statusData.authenticated === true;
          const isHealthConnected = statusData.health && statusData.health.status === 'connected';
          this.isWhatsappConnected = isAuthenticated && isHealthConnected;
          // Store phone number if available
          if (statusData.phone) {
            this.whatsappStatus.phone = statusData.phone;
          }
        } else {
          // Fallback for old format
          this.isWhatsappConnected = response && (
            (response.status === 'authenticated') ||
            (response.authenticated === 1) ||
            (response.authenticated === true)
          );
        }

        // If just connected, close the popup
        if (this.isWhatsappConnected && !wasConnected) {
          console.log('WhatsApp connected! Closing popup...');
          this.closeWhatsappQRDialog();
        }
      },
      error: (err) => {
        console.error('Polling status check failed:', err);
      }
    });
  }
}